module.exports = require("web3-net");